import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SocialLinks from "./common/SocialLinks";
import { getCurrentYear } from "../utils/formatters";

function Footer() {
  const year = getCurrentYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Designed and Developed by Amit Halfon</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} amithalfon</h3>
        </Col>
        <Col md="4" className="footer-body">
          <SocialLinks variant="footer" />
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
